export class ExportTemplateModel {
  /**
  * The name of the template
  */
  templateName: string;

  /**
   * The version number of the template
   */
  version: number;

  /**
   * The comment associated with the template
   */
  comment: string;

  /**
   * The description of the template
   */
  description: string;

  /**
   * The color of the header row in the template
   */
  headerRowColor: string;

  /**
   * The font color of the header row in the template
   */
  headerRowFontColor: string;

  /**
   * The color of even rows in the template
   */
  evenRowColor: string;

  /**
   * The font color of even rows in the template
   */
  evenRowFontColor: string;

  /**
   * The color of odd rows in the template
   */
  oddRowColor: string;

  /**
   * The font color of odd rows in the template
   */
  oddRowFontColor: string;

  /**
   * The name of the worksheet in the template
   */
  worksheetName: string;

  /**
   * Constructor
   */
  constructor(data?: any, isCreatedCopyExportTemplate = false) {
    if (data?.templateName) {
      if (isCreatedCopyExportTemplate) {
        this.templateName = "Copy of " + data?.templateName;
      }
      else {
        this.templateName = data?.templateName;
      }
    }
    else {
      this.templateName = '';
    }
    this.version = data?.version ?? "";
    this.comment = data?.comment ?? "";
    this.description = data?.description ?? "";
    this.headerRowColor = data?.headerRowColor ?? "#E30613";
    this.headerRowFontColor = data?.headerRowFontColor ?? "#FFFFFF";
    this.evenRowColor = data?.evenRowColor ?? "#D8D8D9";
    this.evenRowFontColor = data?.evenRowFontColor ?? "#000000";
    this.oddRowColor = data?.oddRowColor ?? "#EBECEC";
    this.oddRowFontColor = data?.oddRowFontColor ?? "#000000";
    this.worksheetName = data?.worksheetName ?? "Export";
  }
}
